/*
 * File: CustomerPOInput.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 17 May 2021 2:09:34 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Form, Input, Typography } from 'antd';
import { CreateSalesOrderType } from 'common/enums/CreateSalesOrderType';
import { useFormikContext } from 'formik';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { SalesOrderPayloadModel } from 'models/SalesOrderPayloadModel';
import React from 'react';
import { useLocation } from 'react-router-dom';
const { Title } = Typography;

const styles: InlineStylesModel = {
  formItem: {
    marginBottom: 10
  },
  formItemCol: {
    marginRight: '16px',
    maxHeight: '42px'
  },
  titleColor: {
    color: '#2F5596'
  }
};

export const CustomerPOInput = (): JSX.Element => {
  const {
    values: { customerPo },
    handleChange
  } = useFormikContext<SalesOrderPayloadModel>();

  const { pathname } = useLocation();
  const isPosted = pathname.includes('/posted');

  return (
    <>
      <Title level={5} style={styles.titleColor}>
        {CreateSalesOrderType.CUSTOMER_PO} Number
      </Title>
      <Form.Item style={styles.formItem} hasFeedback help={!customerPo ? 'Required to Save and Post' : null}>
        <Input disabled={isPosted} name="customerPo" value={customerPo ?? undefined} allowClear onChange={handleChange} />
      </Form.Item>
    </>
  );
};
